import { render, staticRenderFns } from "./OnlineCustomLabel.vue?vue&type=template&id=7c5460ec&"
import script from "./OnlineCustomLabel.vue?vue&type=script&lang=js&"
export * from "./OnlineCustomLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports